import React from 'react';

const DeliveryStopList = ({ stops }) => {
  return (
    <div className="bg-white rounded-2xl p-4 border border-[#0a1628]/8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xs font-bold text-[#0a1628]/40 uppercase tracking-wider">Delivery Stops</h3>
        <span className="text-xs font-semibold text-[#0a1628]/40 bg-[#0a1628]/6 rounded-full px-2.5 py-1">
          {stops?.filter(s => s?.status === 'completed')?.length}/{stops?.length} done
        </span>
      </div>

      <div className="space-y-3">
        {stops?.map((stop, i) => {
          const isCompleted = stop?.status === 'completed';
          const isActive = stop?.status === 'active';
          const isPending = stop?.status === 'pending';

          return (
            <div key={stop?.id} className={`flex gap-3 p-3 rounded-xl transition-all duration-300 ${
              isActive ? 'bg-[#ffd700]/10 border border-[#ffd700]/30' :
              isCompleted ? 'bg-green-50 border border-green-100': 'bg-[#0a1628]/3 border border-transparent'
            }`}>
              {/* Stop number */}
              <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5 ${
                isCompleted ? 'bg-green-500 text-white' : isActive ?'bg-[#ffd700] text-[#0a1628]': 'bg-[#0a1628]/15 text-[#0a1628]/50'
              }`}>
                {isCompleted ? (
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                ) : (
                  i + 1
                )}
              </div>

              {/* Stop details */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className={`text-sm font-semibold truncate ${isCompleted ? 'text-[#0a1628]/50 line-through' : 'text-[#0a1628]'}`}>
                      {stop?.address}
                    </p>
                    <p className="text-xs text-[#0a1628]/40 mt-0.5">{stop?.recipient}</p>
                    {stop?.note && (
                      <p className="text-xs text-[#0a1628]/30 mt-0.5 italic">{stop?.note}</p>
                    )}
                  </div>
                  {/* Status badge */}
                  <div className={`flex-shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold ${
                    isCompleted ? 'bg-green-100 text-green-700' : isActive ?'bg-[#ffd700]/20 text-[#0a1628]': 'bg-[#0a1628]/8 text-[#0a1628]/40'
                  }`}>
                    {isCompleted ? 'Done' : isActive ? 'Next' : 'Pending'}
                  </div>
                </div>

                {/* ETA for active stop */}
                {isActive && (
                  <div className="flex items-center gap-1 mt-1.5">
                    <svg viewBox="0 0 24 24" fill="#ffd700" className="w-3 h-3">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
                    </svg>
                    <span className="text-xs font-medium text-[#0a1628]/60">~{stop?.eta} min away</span>
                  </div>
                )}
                {isCompleted && stop?.completedAt && (
                  <p className="text-xs text-green-600 mt-1">Delivered at {stop?.completedAt}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DeliveryStopList;
